import React from 'react';
import type { DraggingStyle, NotDraggingStyle } from 'react-beautiful-dnd';

export const lockAxisInTransformStyle = (
  axis: 'X' | 'Y',
  style: React.CSSProperties | DraggingStyle | NotDraggingStyle | undefined,
): React.CSSProperties | undefined => {
  if (style && 'transform' in style && style.transform) {
    const axisLock =
      axis === 'X'
        ? `${style.transform.split(',').shift()}, 0px)`
        : `translate(0px,${style.transform.split(',').pop()}`;

    return {
      ...style,
      transform: axisLock,
    };
  }

  return style as React.CSSProperties | undefined;
};
